import React, { useState } from 'react';
import { X } from 'lucide-react';
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50" onClick={onClose} data-id="element-24">
      <div className="bg-white rounded-xl max-w-2xl w-full max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-25">
        <div className="flex items-center justify-between p-4 border-b border-gray-200 sticky top-0 bg-white" data-id="element-26">
          <h2 className="text-lg font-bold text-dark" data-id="element-27">{title}</h2>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-full transition-colors" data-id="element-28">
            <X className="w-5 h-5 text-gray-500" data-id="element-29" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-sm text-gray-700 leading-relaxed" data-id="element-30">
          {children}
        </div>
      </div>
    </div>;
}
export function LegalFooter() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | 'disclaimer' | null>(null);
  return <>
      <div className="w-full bg-gray-50 border-t border-gray-200 py-3 text-center" data-id="element-31">
        <p className="text-xs text-gray-500 mb-2" data-id="element-32">
          © {new Date().getFullYear()} Life Freedom. Todos los derechos
          reservados.
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap" data-id="element-33">
          <button onClick={() => setActiveModal('privacy')} className="text-xs text-primary hover:underline font-medium" data-id="element-34">
            Política de Privacidad
          </button>
          <span className="text-gray-300" data-id="element-35">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-xs text-primary hover:underline font-medium" data-id="element-36">
            Términos y Condiciones
          </button>
          <span className="text-gray-300" data-id="element-37">|</span>
          <button onClick={() => setActiveModal('disclaimer')} className="text-xs text-primary hover:underline font-medium" data-id="element-38">
            Descargo de Responsabilidad
          </button>
        </div>
      </div>

      {/* Privacy Policy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-39">
        <div className="space-y-4" data-id="element-40">
          <p className="font-semibold" data-id="element-41">
            Última actualización: {new Date().toLocaleDateString('es-ES')}
          </p>

          <section data-id="element-42">
            <h3 className="font-bold text-base mb-2" data-id="element-43">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-44">
              Recopilamos información personal que usted nos proporciona
              voluntariamente, incluyendo:
            </p>
            <ul className="list-disc ml-6 mt-2 space-y-1" data-id="element-45">
              <li data-id="element-46">Nombre completo</li>
              <li data-id="element-47">Edad o rango de edad</li>
              <li data-id="element-48">Estado de residencia</li>
              <li data-id="element-49">Número de teléfono</li>
              <li data-id="element-50">Correo electrónico</li>
              <li data-id="element-51">Objetivos financieros</li>
            </ul>
          </section>

          <section data-id="element-52">
            <h3 className="font-bold text-base mb-2" data-id="element-53">
              2. Uso de la Información
            </h3>
            <p data-id="element-54">Utilizamos su información para:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1" data-id="element-55">
              <li data-id="element-56">
                Contactarlo para proporcionarle cotizaciones personalizadas
              </li>
              <li data-id="element-57">Conectarlo con asesores certificados de seguros</li>
              <li data-id="element-58">Mejorar nuestros servicios y experiencia del usuario</li>
              <li data-id="element-59">Cumplir con requisitos legales y regulatorios</li>
            </ul>
          </section>

          <section data-id="element-60">
            <h3 className="font-bold text-base mb-2" data-id="element-61">3. Protección de Datos</h3>
            <p data-id="element-62">
              Implementamos medidas de seguridad de nivel bancario, incluyendo
              cifrado SSL de 256 bits, para proteger su información personal
              contra acceso no autorizado, alteración o divulgación.
            </p>
          </section>

          <section data-id="element-63">
            <h3 className="font-bold text-base mb-2" data-id="element-64">
              4. Compartir Información
            </h3>
            <p data-id="element-65">Podemos compartir su información con:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1" data-id="element-66">
              <li data-id="element-67">Asesores de seguros certificados y autorizados</li>
              <li data-id="element-68">
                Proveedores de servicios que nos ayudan a operar nuestro negocio
              </li>
              <li data-id="element-69">Autoridades cuando sea requerido por ley</li>
            </ul>
          </section>

          <section data-id="element-70">
            <h3 className="font-bold text-base mb-2" data-id="element-71">5. Sus Derechos</h3>
            <p data-id="element-72">
              Usted tiene derecho a acceder, corregir o eliminar su información
              personal en cualquier momento. Para ejercer estos derechos,
              contáctenos.
            </p>
          </section>
        </div>
      </Modal>

      {/* Terms and Conditions Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-73">
        <div className="space-y-4" data-id="element-74">
          <p className="font-semibold" data-id="element-75">
            Última actualización: {new Date().toLocaleDateString('es-ES')}
          </p>

          <section data-id="element-76">
            <h3 className="font-bold text-base mb-2" data-id="element-77">
              1. Aceptación de Términos
            </h3>
            <p data-id="element-78">
              Al utilizar este sitio web y proporcionar su información, usted
              acepta estos términos y condiciones en su totalidad.
            </p>
          </section>

          <section data-id="element-79">
            <h3 className="font-bold text-base mb-2" data-id="element-80">2. Servicios Ofrecidos</h3>
            <p data-id="element-81">
              Life Freedom proporciona servicios de conexión entre consumidores
              y asesores certificados de seguros de vida indexados universales
              (IUL). No somos una compañía de seguros ni vendemos pólizas
              directamente.
            </p>
          </section>

          <section data-id="element-82">
            <h3 className="font-bold text-base mb-2" data-id="element-83">3. Consulta Gratuita</h3>
            <p data-id="element-84">
              La consulta inicial con un asesor es completamente gratuita y sin
              compromiso. No está obligado a comprar ningún producto o servicio.
            </p>
          </section>

          <section data-id="element-85">
            <h3 className="font-bold text-base mb-2" data-id="element-86">
              4. Exactitud de la Información
            </h3>
            <p data-id="element-87">
              Usted se compromete a proporcionar información precisa y
              actualizada. La información inexacta puede afectar las
              cotizaciones y recomendaciones que reciba.
            </p>
          </section>

          <section data-id="element-88">
            <h3 className="font-bold text-base mb-2" data-id="element-89">5. Comunicaciones</h3>
            <p data-id="element-90">
              Al proporcionar su información de contacto, usted acepta recibir
              comunicaciones de Life Freedom y asesores asociados por teléfono,
              correo electrónico o WhatsApp.
            </p>
          </section>

          <section data-id="element-91">
            <h3 className="font-bold text-base mb-2" data-id="element-92">6. Modificaciones</h3>
            <p data-id="element-93">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. El uso continuado del sitio después de cambios constituye
              aceptación de los nuevos términos.
            </p>
          </section>
        </div>
      </Modal>

      {/* Disclaimer Modal */}
      <Modal isOpen={activeModal === 'disclaimer'} onClose={() => setActiveModal(null)} title="Descargo de Responsabilidad" data-id="element-94">
        <div className="space-y-4" data-id="element-95">
          <section data-id="element-96">
            <h3 className="font-bold text-base mb-2" data-id="element-97">Información General</h3>
            <p data-id="element-98">
              La información proporcionada en este sitio web es solo para fines
              informativos generales. No constituye asesoramiento financiero,
              legal o fiscal profesional.
            </p>
          </section>

          <section data-id="element-99">
            <h3 className="font-bold text-base mb-2" data-id="element-100">
              Seguros de Vida Indexados Universales (IUL)
            </h3>
            <p data-id="element-101">
              Los seguros de vida indexados universales son productos
              financieros complejos que pueden no ser adecuados para todos. Los
              rendimientos están vinculados a índices del mercado y pueden
              variar. No hay garantía de rendimientos específicos.
            </p>
          </section>

          <section data-id="element-102">
            <h3 className="font-bold text-base mb-2" data-id="element-103">Riesgos</h3>
            <ul className="list-disc ml-6 space-y-1" data-id="element-104">
              <li data-id="element-105">
                Los valores en efectivo pueden fluctuar según el rendimiento del
                índice
              </li>
              <li data-id="element-106">
                Existen tarifas, cargos y limitaciones que pueden afectar el
                rendimiento
              </li>
              <li data-id="element-107">
                Las garantías están respaldadas por la capacidad de pago de la
                compañía emisora
              </li>
              <li data-id="element-108">
                El acceso anticipado a fondos puede resultar en penalidades e
                impuestos
              </li>
            </ul>
          </section>

          <section data-id="element-109">
            <h3 className="font-bold text-base mb-2" data-id="element-110">
              No Somos Asesores Financieros
            </h3>
            <p data-id="element-111">
              Life Freedom actúa como intermediario para conectar consumidores
              con asesores certificados. No proporcionamos asesoramiento
              financiero directo. Todas las recomendaciones provienen de
              asesores independientes licenciados.
            </p>
          </section>

          <section data-id="element-112">
            <h3 className="font-bold text-base mb-2" data-id="element-113">
              Consulte a un Profesional
            </h3>
            <p data-id="element-114">
              Antes de tomar cualquier decisión financiera, le recomendamos
              encarecidamente consultar con un asesor financiero, contador o
              abogado calificado que pueda evaluar su situación personal.
            </p>
          </section>

          <section data-id="element-115">
            <h3 className="font-bold text-base mb-2" data-id="element-116">
              Resultados No Garantizados
            </h3>
            <p data-id="element-117">
              Los ejemplos, testimonios o proyecciones mostradas son
              ilustrativos y no garantizan resultados futuros. El rendimiento
              pasado no es indicativo de resultados futuros.
            </p>
          </section>

          <section data-id="element-118">
            <h3 className="font-bold text-base mb-2" data-id="element-119">
              Limitación de Responsabilidad
            </h3>
            <p data-id="element-120">
              Life Freedom no se hace responsable por decisiones tomadas basadas
              en la información de este sitio o por las acciones de asesores
              independientes. Usted asume toda la responsabilidad por sus
              decisiones financieras.
            </p>
          </section>
        </div>
      </Modal>
    </>;
}